export const BUCKET_ORDER = ['0-1 hr', '1-2 hrs', '2-4 hrs', '4-6 hrs', '6-8 hrs', '8-12 hrs', '12+ hrs'];

// 7-step "distance" ramp. The long-haul bands move off red into
// violet→fuchsia→blue: three shades of red (red-500/700/900) were
// near-indistinguishable as small legend dots and donut slices (markup #86),
// so the top steps now use distinct cool hues while still reading as
// escalating distance.
export const BUCKET_COLORS = {
  '0-1 hr':   '#10B981', // emerald
  '1-2 hrs':  '#84CC16', // lime
  '2-4 hrs':  '#EAB308', // yellow
  '4-6 hrs':  '#F97316', // orange
  '6-8 hrs':  '#7C3AED', // violet
  '8-12 hrs': '#A21CAF', // fuchsia
  '12+ hrs':  '#2563EB', // blue
  unknown:    '#9CA3AF',
};

export const BUCKET_LABELS = {
  '0-1 hr':   'Local',
  '1-2 hrs':  'Short drive',
  '2-4 hrs':  'Regional',
  '4-6 hrs':  'Destination',
  '6-8 hrs':  'Long haul',
  '8-12 hrs': 'Endurance',
  '12+ hrs':  'Cross-country',
};

export function driveTimeBucket(seconds) {
  if (seconds == null || Number.isNaN(Number(seconds))) return 'unknown';
  const s = Number(seconds);
  if (s <= 3600)  return '0-1 hr';
  if (s <= 7200)  return '1-2 hrs';
  if (s <= 14400) return '2-4 hrs';
  if (s <= 21600) return '4-6 hrs';
  if (s <= 28800) return '6-8 hrs';
  if (s <= 43200) return '8-12 hrs';
  return '12+ hrs';
}

// 0-100 rating → color (5-tier scale per spec p.13)
export function ratingColor(score) {
  if (score == null || Number.isNaN(Number(score))) return '#9CA3AF';
  const n = Number(score);
  if (n >= 80) return '#10B981';
  if (n >= 60) return '#84CC16';
  if (n >= 40) return '#EAB308';
  if (n >= 30) return '#F97316';
  return '#EF4444';
}

// Scatter-plot palette for site categories (Section 4B)
export const SITE_CATEGORY_COLORS = {
  'Cabin':       '#8B5CF6',
  'RV Site':     '#32B1FF',
  'Tent':        '#10B981',
  'Glamping':    '#F97316',
  'Lodge':       '#EC4899',
  'default':     '#9CA3AF',
};

export function siteCategoryColor(category) {
  return SITE_CATEGORY_COLORS[category] || SITE_CATEGORY_COLORS.default;
}

// Congestion color by tax % of total drive time (spec p.11)
export function congestionColor(seconds, driveTimeSeconds) {
  if (seconds == null || !driveTimeSeconds) return '#9CA3AF';
  const pct = (Number(seconds) / Number(driveTimeSeconds)) * 100;
  if (pct < 5)  return '#10B981';
  if (pct < 15) return '#EAB308';
  return '#EF4444';
}
